export default __webpack_public_path__ + "static/media/guide_03.58e64c5c.md";